import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { AppConfig } from '../app/app-config';

@Injectable()
export class UserserviceProvider { 
  constructor(public http: HttpClient, public storage: Storage, public appConfig: AppConfig) {
    console.log('Hello UserserviceProvider Provider');
  }
  
   getProducts(category_id: string): void
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "product", category_id: category_id},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }
   
   getProductTypes(): void
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "type"},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }
   
   
      
   getProductTypes2(): void
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "type2"},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }  
   
   
   getColors(): void 
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "colors"},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }
   
    
    getGriffeAll(griffe_cat, griffe_subcat): void 
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "griffe_all", griffe_cat: griffe_cat, griffe_subcat: griffe_subcat},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)
   }
   
    getVerglasung(verglasung_cat): void 
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "verglasung", verglasung_cat: verglasung_cat},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)
   }
   
    getSprossen(sprossen_cat): void 
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "sprossen", sprossen_cat: sprossen_cat},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)
   }
   
      getRahmen(): void 
   {
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "rahmen"},
    url: any = this.appConfig.baseURI + "retrieve-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }
   

  sendMail(cartItems, personalData): void 
   {
   console.log(cartItems, personalData);
   let headers: any = new HttpHeaders({ 'Content-Type': 'application/json' }),
    options: any = { key: "sendMail", cartItems, personalData},
    url: any = this.appConfig.baseURI + "manage-data.php"; 
    
     return this.http.post(url, JSON.stringify(options), headers)

   }
   

} 




// WEBPACK FOOTER //
// ./src/providers/userservice.ts